import {
  AddEventFailure,
  AddEventsResponse,
  AthenaEvent,
} from "@evidenceb/athena-event-storage-schemas";
import {
  AthenaEventSaveError,
  makeAddition,
  makeUnauthorized,
  makeUniqueViolation,
  makeUnknown,
  makeValidation,
} from "../../AthenaEventSaveError/AthenaEventSaveError.js";
import { AthenaEventSaveResult } from "../AthenaEventSaveResult.js";

export type PostEventsRequestBody = AthenaEvent<any, any>[];

export type PostEventsResponseBody = AddEventsResponse;

export function toAthenaEventSaveResults(
  response: { status: 200 | 400; body: PostEventsResponseBody },
  request: { body: PostEventsRequestBody },
): AthenaEventSaveResult[] {
  return request.body.map((athenaEvent, index) => {
    return response.body.successes?.includes(athenaEvent.id)
      ? {
          athenaEvent: athenaEvent,
          succeeded: true,
          error: null,
        }
      : {
          athenaEvent: athenaEvent,
          succeeded: false,
          error: getErrorFromFailure(response.body.failures?.[index]),
        };
  });
}

function getErrorFromFailure(
  failure: AddEventFailure | undefined,
): AthenaEventSaveError {
  if (!failure) {
    return makeUnknown(
      "Save result did not report AthenaEvent save as neither successful nor failed.",
    );
  }
  switch (failure.type) {
    case "UniqueViolation":
      return makeUniqueViolation(failure.message);
    case "AuthorizationError":
      return makeUnauthorized(failure.message);
    case "AdditionError":
      return makeAddition(failure.message);
    case "ValidationError":
      return makeValidation(failure.message);
  }
}
